import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosService } from 'app/services/parametros.service';
import { PagareService } from 'app/services/pagare.service';
import { take } from 'rxjs';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';

@Component({
    selector: 'editor-plantilla',
    templateUrl: './editor-plantilla.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class EditorPlantillaComponent implements OnInit {
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlert: boolean = false;
    guardando: boolean = false;
    modalVariables: boolean = false;

    infoPlantilla: {
        originalName: string;
        name: string;
        body: string;
    } = {
        originalName: null,
        name: null,
        body: null,
    };
    init: any = {
        //height: 400,
        //theme: 'modern',
        base_url: '/tinymce',
        suffix: '.min',
        visual: false,
        branding: false,
        language: 'es',
        language_url: '/assets/tinymce/langs/es.js',
        plugins:
            'advlist autolink lists link image charmap preview anchor \
            searchreplace visualblocks fullscreen \
            insertdatetime media table code wordcount',
        toolbar:
            'undo redo | code | preview | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent',
        image_advtab: true,
        mobile: {
            plugins: ['autosave', 'code', 'lists', 'autolink', 'preview'],
            toolbar: ['undo', 'code', 'preview', 'bold'],
        },
    };

    variablesPersonalizacion = [
        { NOMBRE: 'FOLIO', DESCRIPCION: 'Folio del pagaré' },
        { NOMBRE: 'RAZON_SOCIAL', DESCRIPCION: 'Nombre del receptor del pagaré' },
        { NOMBRE: 'RUTDV', DESCRIPCION: 'Indentificado fiscal del receptor del pagaré' },
        { NOMBRE: 'MONTO_TOTAL', DESCRIPCION: 'Monto total del pagaré' },
        { NOMBRE: 'MONTO_TOTAL_PALABRAS', DESCRIPCION: 'Monto total del pagaré en palabras' },
        { NOMBRE: 'FECHA_CONTRATO', DESCRIPCION: 'Fecha de firma del contrato' },
        { NOMBRE: 'NRO_CONTRATO', DESCRIPCION: 'Numero del contrato' },
        { NOMBRE: 'DIRECCION', DESCRIPCION: 'Dirección del receptor del pagaré' },
        { NOMBRE: 'COMUNA', DESCRIPCION: 'Comuna del receptor del pagaré' },
        { NOMBRE: 'CIUDAD', DESCRIPCION: 'Ciudad del receptor del pagaré' },
        { NOMBRE: 'FECHA_CREACION', DESCRIPCION: 'Fecha de generación del pagaré' },
        { NOMBRE: 'EMP_NOMBRE', DESCRIPCION: 'Nombre empresa' },
        { NOMBRE: 'EMP_RUT', DESCRIPCION: 'Rut empresa' },
        { NOMBRE: 'EMP_DIRECCION', DESCRIPCION: 'Dirección empresa' },
        { NOMBRE: 'EMP_COMUNA', DESCRIPCION: 'Comuna empresa' },
        { NOMBRE: 'EMP_CIUDAD', DESCRIPCION: 'Ciudad empresa' },
        { NOMBRE: 'EMP_REPRESENTANTE_LEGAL', DESCRIPCION: 'Nombre de quien comparece por Claro' },
        { NOMBRE: 'EMP_FECHA_ESCRITURA_PUBLICA', DESCRIPCION: 'Fecha escritura pública' },
    ];

    constructor(private actvatedRoute: ActivatedRoute, private _plantilla: ParametrosService, private route: Router) {}

    ngOnInit(): void {
        let ID_PLANTILLA = this.actvatedRoute.snapshot.params.ID;
        //console.log('id1:' + ID_PLANTILLA);
        if (!ID_PLANTILLA) {
            this.infoPlantilla = {
                originalName: null,
                name: null,
                body: null,
            };
            return;
        }
        // console.log('id:' + ID_PLANTILLA);
        this._plantilla
            .getPlantilla(ID_PLANTILLA)
            .pipe(take(1))
            .subscribe({
                next: (plantilla) => {
                    this.infoPlantilla = {
                        originalName: plantilla.name,
                        name: plantilla.name,
                        body: plantilla.plantillaHtml,
                    };
                    // console.log(plantilla);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }

    guardarPlantilla() {
        if (!this.infoPlantilla) {
            return;
        }

        this.guardando = true;
        this._plantilla
            .postPlantilla(this.infoPlantilla)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.guardando = false;
                    this.alert = {
                        type: 'success',
                        message: 'Configuración guardada',
                    };
                    this.infoPlantilla.originalName = this.infoPlantilla.name;
                    this.alertShow();
                    //console.log(correo);
                },
                error: (err) => {
                    console.log(err);
                    switch (err.status) {
                        default:
                            this.alert = {
                                type: 'error',
                                message: 'No se pudo completar la operación',
                            };
                            break;
                    }

                    this.alertShow();
                    this.guardando = false;
                },
                complete: () => {},
            });
    }

    goback(): void {
        this.route.navigateByUrl('home/sistema/plantillas');
    }

    alertShow() {
        this.showAlert = true;
        setTimeout(() => {
            this.showAlert = false;
        }, 3000);
    }
}
